// extracted by mini-css-extract-plugin
export default {"visible":"BottomMenu_visible__k284q","devVisible":"BottomMenu_devVisible__2sVHO"};